<template>
  <!-- 到期提示 -->
  <div v-if="isExpired" class="expire-banner">
    <div class="expire-banner-content">
      <span class="expire-banner-title">房源已到期</span>
      <span class="expire-banner-info">到期时间：{{ expireDate }}</span>
      <span class="expire-banner-renew">续费路径：手机端 我的->房源管理->购买付费</span>
    </div>
  </div>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div v-if="!isExpired" class="lef-one">
        <a-button class="btn-primary" @click="handleAdd">创建房间</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search
            v-model:value="searchForm.name"
            :loading="searchLoading"
            placeholder="请输入房间名称"
            @search="getTableList"
        >
        </a-input-search>
      </div>
      <div class="rig-group">
        <!-- <div ref="ref1" @click="handleOpen(ref1)">
          <a-button @click="handleAdd" class="f-c-bf"
            >房间/房型<down-outlined class="f-12"
          /></a-button>
        </div> -->
        <div class="group-one">
          <a-select
              v-model:value="searchForm.gid"
              :dropdownMatchSelectWidth="false"
              :filterOption="groupFilter"
              :max-tag-count="1"
              mode="multiple"
              placeholder="分组"
              @change="getTableList()"
              @dropdownVisibleChange="getGroup"
          >
            <a-select-option
                v-for="(item, index) in GroupList"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <div class="group-one">
          <a-select
              v-model:value="searchForm.rid"
              :dropdownMatchSelectWidth="false"
              :filterOption="roomFilter"
              placeholder="房型"
              show-search
              @change="getTableList()"
              @dropdownVisibleChange="getRoom"
          >
            <a-select-option
                v-for="(item, index) in RoomList.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </div>
        <!-- <div class="group-one">
          <a-select
            v-model:value="searchForm.ota_id"
            placeholder="子账号"
            @change="getTableList"
          >
            <a-select-option
              :value="item.ota_id"
              v-for="(item, index) in CompanyOta"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div> -->
      </div>

      <!-- <div class="rig-one">
        <a-button @click="handleAdd">批量分组</a-button>
      </div> -->
      <div class="rig-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'name'">
        <div style="display: flex">
          <img
              :src="imgCut(record.image ? record.image : companyLogo, 'xl')"
              alt="房源图片"
              fit="fill"
              style="
              width: 80px;
              height: 50px;
              object-fit: cover;
              cursor: pointer;
            "
              @click="goRouter('/pms/landlord/house/details', record)"
          />
          <div class="house-info">
            <div class="editable-cell">
              <div
                  v-if="editId.includes(record.id)"
                  class="editable-cell-input-wrapper"
              >
                <a-input v-model:value="record.name" size="small"></a-input
                >
                <check-outlined
                    class="editable-cell-icon-check"
                    @click="editSave(record)"
                />
              </div>
              <div v-else class="editable-cell-text-wrapper">
                {{
                  record.name
                }}
                <edit-outlined
                    class="f-c-999 editable-cell-icon"
                    style="margin-left: 10px; cursor: pointer"
                    @click="editId.push(record.id)"
                />
              </div>
            </div>

            <div class="f-c-999 f-12">
              {{ record.rname }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="column.key == 'channel'">
        <div class="logo">
          <a-avatar
              v-for="(item, index) of record.ota_list"
              :key="index"
              :size="20"
              :src="item.logo"
              :title="item.ota_name"
              class="avatar"
          />
          <plus-circle-outlined
              class="f-20"
              style="color: #1890ff; cursor: pointer"
              @click="goRouter('/pms/landlord/house/details', record, 4)"
          />
        </div>
      </template>
      <template v-if="column.key == 'checkIn'">
        <plus-circle-outlined
            class="f-20"
            style="color: #1890ff; cursor: pointer"
            @click="goRouter('/pms/landlord/house/details', record)"
        />
      </template>
      <template v-if="column.key == 'operate'">
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <DownOutlined/>
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="handleJoin(record)">
                <div>加入分组</div>
              </a-menu-item>
              <!-- <a-menu-item @click="handleAddEdit(record)">
                <div>退出分组</div>
              </a-menu-item> -->
              <a-menu-item @click="handleDel(record)">
                <div class="f-c-red">移除此房间</div>
              </a-menu-item>
              <a-menu-item @click="handleForceDel(record)">
                <div class="f-c-red">强制删除</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination
      :pageTotal="pageTotal"
      @onShowSizeChange="onShowSizeChange"
      @pageChange="pageChange"
  />

  <!-- 房间房型弹窗 -->
  <!-- <a-modal
    v-model:visible="visibleRoom"
    :width="400"
    :closable="false"
    style="position: absolute"
    :bodyStyle="{ padding: 0 }"
    :style="{ left: positionModal.left + 'px', top: positionModal.top + 'px' }"
    :mask="false"
  >
    <div class="modal-header">
      <a-button
        class="btn-primary"
        shape="round"
        size="small"
        style="margin-right: 10px"
        >分组</a-button
      >
      <a-button shape="round" size="small">房型</a-button>
    </div>
    <div class="modal-content">
      <div class="opt-one">分组1</div>
      <div class="opt-one">分组2</div>
    </div>
  </a-modal> -->

  <!-- 地图定位 -->
  <map-select
      v-if="visibleMap"
      :latitude="addForm.latitude"
      :longitude="addForm.longitude"
      :showMap="visibleMap"
      @address="
      (params) => {
        addForm.address = params;
      }
    "
      @close="visibleMap = false"
      @selectValue="selectMap"
  />
  <!-- <a-modal
    v-model:visible="visibleMap"
    :footer="null"
    :mask="false"
    title="地图定位"
    :width="800"
    :bodyStyle="{ padding: '0' }"
  >
    <div style="width: 800px; height: 700px">
      <iframe
        :src="src"
        :allowfullscreen="true"
        width="100%"
        height="100%"
        frameborder="0"
      >
      </iframe>
    </div>
  </a-modal> -->

  <!-- 添加房间弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :footer="null"
      :width="600"
      title="创建房间"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        labelAlign="left"
    >
      <div v-show="!isNext">
        <div class="f-c-999" style="margin-bottom: 15px">
          请根据实际的房间数量创建，此名称仅内部使用，建议简短
        </div>
        <a-form-item v-for="(item, index) in addList" :key="index">
          <a-input
              v-model:value="item.name"
              :maxlength="30"
              placeholder="请输入房间名称(30字内)"
              style="width: 95%"
          ></a-input>
          <close-circle-outlined
              v-if="addList.length > 1"
              class="f-c-999 f-18"
              style="margin-left: 5px"
              @click="removeRow(index)"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="dashed" @click="addRow">
            <PlusOutlined/>
            添加
          </a-button>
        </a-form-item>
      </div>
      <div v-show="isNext">
        <div class="modal-ctitle">基本信息</div>
        <a-form-item label="可住人数：" name="capacity">
          <a-input-number
              v-model:value="addForm.capacity"
              :min="1"
              placeholder="请输入可住人数"
              style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="所在区域：" name="province_id">
          <AreaSelect v-if="visibleAdd" @changeArea="changeArea"/>
        </a-form-item>
        <a-form-item label="导航定位：" name="latitude">
          <a-select
              v-model:value="location"
              :open="false"
              placeholder="请选择定位"
              style="width: 100%"
              @click="handleOpenMap()"
          ></a-select>
        </a-form-item>
        <a-form-item label="详细地址：" name="address">
          <a-textarea
              v-model:value="addForm.address"
              :rows="2"
              placeholder="请输入详细地址"
              style="width: 100%"
          ></a-textarea>
        </a-form-item>

        <a-form-item label="分组：">
          <a-select
              v-model:value="addForm.gid"
              :filterOption="groupFilter"
              :max-tag-count="2"
              allowClear
              mode="multiple"
              placeholder="请选择分组"
              @dropdownVisibleChange="getGroup"
          >
            <a-select-option
                v-for="(item, index) in GroupList"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="房型：">
          <a-select
              v-model:value="addForm.rid"
              :filterOption="roomFilter"
              allowClear
              placeholder="请选择房型"
              show-search
              @dropdownVisibleChange="getRoom"
          >
            <a-select-option
                v-for="(item, index) in RoomList.list"
                :key="index"
                :value="item.id"
            >{{ item.name }}
            </a-select-option
            >
          </a-select>
        </a-form-item>
        <div class="modal-ctitle">价格策略</div>
        <a-form-item label="周日-周四：" name="sun_to_thur">
          <a-input
              v-model:value="addForm.sun_to_thur"
              placeholder="请输入价格"
              prefix="￥"
              style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="周五-周六：" name="fri_to_sat">
          <a-input
              v-model:value="addForm.fri_to_sat"
              placeholder="请输入价格"
              prefix="￥"
              style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="节假日：" name="holiday">
          <a-input
              v-model:value="addForm.holiday"
              placeholder="请输入价格"
              prefix="￥"
              style="width: 100%"
          />
        </a-form-item>
      </div>

      <div style="text-align: right">
        <template v-if="!isNext">
          <a-button @click="visibleAdd = false">取消</a-button>

          <a-button
              class="btn-primary"
              style="margin-left: 8px"
              @click="handleNext"
          >下一步
          </a-button
          >
        </template>
        <template v-else>
          <a-button @click="isNext = false">上一步</a-button>
          <a-button
              class="btn-primary"
              style="margin-left: 8px"
              @click="handleAddSave"
          >确定
          </a-button
          >
        </template>
      </div>
    </a-form>
  </a-modal>

  <!-- 加入分组 -->
  <a-modal v-model:visible="visibleJoin" title="加入分组" @ok="handleJoinSave">
    <a-form-item label="分组：">
      <a-select
          v-model:value="joinGroup"
          :filterOption="groupFilter"
          allowClear
          mode="multiple"
          placeholder="请选择分组"
      >
        <a-select-option
            v-for="(item, index) in GroupList"
            :key="index"
            :value="item.id"
        >{{ item.name }}
        </a-select-option
        >
      </a-select>
    </a-form-item>
  </a-modal>
</template>

<script>
import {createVNode, onMounted, reactive, toRefs, watch} from "vue";
import {getCompanyConfig, getGroupList, getHouseList, getRoomList, houseAdd, houseDel, houseDetails, houseEdit,} from "@/api/api";
import dayjs from "dayjs";
import {
  CheckOutlined,
  CloseCircleOutlined,
  DownOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import {message, Modal} from "ant-design-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import AreaSelect from "@/components/pms/landlord/AreaSelect/AreaSelect.vue";
import MapSelect from "@/components/pms/landlord/MapSelect/MapSelect.vue";
import {verifyPrice} from "@/common/validator";
import store from "@/store/pms/landlord/index"; //VUEX
import router from "@/router/index";
import {mapKey} from "../../../../config.js";

export default {
  components: {
    PlusCircleOutlined,
    DownOutlined,
    PlusOutlined,
    CloseCircleOutlined,
    AreaSelect,
    MapSelect,
    EditOutlined,
    CheckOutlined,
  },
  setup() {
    let {imgCut, countModal, countTable} = useUtils();

    // 地图
    const mapselect = reactive({
      visibleMap: false,
      location: [],
      src:
          "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=" +
          mapKey +
          "&referer=平台",
      selectMap(params) {
        modal.addForm.longitude = params.longitude;
        modal.addForm.latitude = params.latitude;
        mapselect.location =
            "经度：" + `${params.latitude}` + "；纬度：" + `${params.longitude}`;
        modal.formRef.validate("latitude");
      },
    });

    // 搜索
    let search = reactive({
      topDom: "",
      isExpired: false,
      expireDate: "",
      searchForm: {
        name: "",
        rid: [],
        gid: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      // 分组数据
      GroupList: [],
      getGroup() {
        getGroupList({
          start: 0,
          limit: 99,
        }).then((res) => {
          search.GroupList = res.data;
        });
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      // 房型数据
      RoomList: [],
      getRoom() {
        getRoomList({
          start: 0,
          limit: 99,
        }).then((res) => {
          search.RoomList = res.data;
        });
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },

      ref1: "",
      positionModal: {}, //定位数据
      handleOpen(params) {
        search.positionModal = countModal(params);
        modal.visibleRoom = true;
      },
      // 重置
      handleReset() {
        search.searchForm.name = "";
        search.searchForm.rid = [];
        search.searchForm.gid = [];
        table.getTableList();
      },
      checkCompanyConfig() {
        getCompanyConfig()
          .then((res) => {
            const data = res.data || {};
            // data.expire = true; // TODO: 临时测试，记得删除
            if (data.expire) {
              search.isExpired = true;
              search.expireDate = data.house_expire_time ? dayjs(data.house_expire_time * 1000).format("YYYY-MM-DD") : "";
            } else {
              search.isExpired = false;
              search.expireDate = "";
            }
            table.getTableList();
          })
          .catch(() => {
            search.isExpired = false;
            search.expireDate = "";
            table.getTableList();
          });
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      editSave(item) {
        houseEdit({
          hid: item.id,
          name: item.name,
        }).then((res) => {
          message.success(res.msg);
          table.editId.splice(table.editId.indexOf(item.id), 1);
        });
      },
      tableHeight: "",
      dataSource: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          width: 80,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "关联的渠道",
          dataIndex: "channel",
          key: "channel",
        },
        {
          title: "入住信息",
          dataIndex: "checkIn",
          key: "checkIn",
        },
        {
          title: "",
          dataIndex: "operate",
          key: "operate",
        },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        getHouseList({
          name: search.searchForm.name,
          gid: search.searchForm.gid.toString(),
          rid: search.searchForm.rid,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      goRouter(url, params = {}, tab = 1) {
        console.log("goRouter-params", params.id)
        router.push({path: url, query: {hid: params.id, tab: tab}});
      },
    });

    // 弹窗
    let modal = reactive({
      visibleRoom: false,
      visibleAdd: false,
      visibleJoin: false,
      CompanyOta: [],
      loading: false,
      getInitData() {
        return {
          name: "",
          capacity: "",
          province_id: "",
          city_id: "",
          area_id: "",
          province_name: "",
          city_name: "",
          area_name: "",
          address: "",
          longitude: "",
          latitude: "",
          gid: [],
          rid: [],
          sun_to_thur: "",
          fri_to_sat: "",
          holiday: "",
        };
      },

      // 打开全部渠道
      handleAdd() {
        modal.visibleAdd = true;
      },
      rowData: "",
      addList: [
        {
          name: "",
        },
      ],
      addForm: {},
      formRef: "", //表单验证
      rules: {
        capacity: [
          {
            required: true,
            type: "number",
            message: "请输入可住人数",
            trigger: "blur",
          },
        ],
        province_id: [
          {
            required: true,
            message: "请选择所在区域",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            type: "number",
            message: "请选择定位",
            trigger: "blur",
          },
        ],
        sun_to_thur: [
          {
            required: false,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        fri_to_sat: [
          {
            required: false,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
        holiday: [
          {
            required: false,
            validator: verifyPrice,
            trigger: "blur",
          },
        ],
      },
      isNext: false, //是否下一步

      // 新增一行
      addRow() {
        modal.addList.push({name: ""});
      },
      // 删除一行
      removeRow(index) {
        modal.addList.splice(index, 1);
      },
      // 下一步
      handleNext() {
        let name = [];
        modal.addList.map((item) => {
          if (item.name) {
            name.push(item.name);
          }
        });
        if (!name.length) {
          message.warning("请输入房间名称");
          return false;
        }
        for (let index in name.sort()) {
          index = Number(index);
          if (name[index] == name[index + 1]) {
            message.warning(`${name[index]}名称重复`);
            return false;
          }
        }
        modal.isNext = true;
      },
      // 打开地图
      handleOpenMap() {
        mapselect.visibleMap = true;
      },
      modalLoading: false,
      // 新增保存
      handleAddSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          let name = [];
          modal.addList.map((item) => {
            if (item.name) {
              name.push(item.name);
            }
          });
          modal.addForm.name = name.toString();
          modal.addForm.gid = modal.addForm.gid.toString();
          modal.addForm.rid = modal.addForm.rid.toString();
          if (!modal.addForm.rid) {
            modal.addForm.price_house = JSON.stringify({
              sun_to_thur: modal.addForm.sun_to_thur,
              fri_to_sat: modal.addForm.fri_to_sat,
              holiday: modal.addForm.holiday,
            });
          }
          houseAdd(modal.addForm)
              .then((res) => {
                message.success(res.msg);
                modal.visibleAdd = false;
                table.getTableList();
                modal.addList = [{name: ""}];
                if (modal.formRef) {
                  modal.formRef.resetFields();
                }
                modal.addForm = modal.getInitData();
                mapselect.location = "";
                modal.isNext = false;
                modal.modalLoading = false;
              })
              .catch(() => {
                modal.addForm.gid = modal.addForm.gid
                    ? modal.addForm.gid.split(",").map(Number)
                    : [];
                modal.addForm.rid = modal.addForm.rid
                    ? modal.addForm.rid.split(",").map(Number)
                    : [];
                modal.modalLoading = false;
              });
        });
      },
      // 选择区域回调
      changeArea(params) {
        Object.assign(modal.addForm, params);
      },
      // 加入分组
      joinGroup: [],
      detailsData: {}, //详情数据
      handleJoin(item) {
        modal.joinGroup = [];
        search.getGroup();
        houseDetails({hid: item.id}).then((res) => {
          modal.joinGroup = res.data.gid
              ? res.data.gid.split(",").map(Number)
              : [];
          modal.detailsData = res.data;
        });
        modal.visibleJoin = true;
      },
      handleJoinSave() {
        let gid = modal.joinGroup.toString();
        houseEdit({
          hid: modal.detailsData.id,
          gid,
        }).then((res) => {
          message.success(res.msg);
          modal.visibleJoin = false;
        });
      },

      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: "确定移除此房间？",
          content:
              "删除房间后，您房间的房态将被删除并无法恢复；房间的订单在订单列表中仍然可被检索，但其将不属于任何一个房间，除非手动换房，否则无法在房态日历中显示；历史统计数据不受影响。",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            houseDel({hid: item.id, force: 0}).then((res) => {
              message.success(res.msg);
              table.getTableList();
            });
          },
        });
      },
      // 强制删除
      handleForceDel(item) {
        Modal.confirm({
          title: "强制删除",
          content:
              "你正在强制删除，今日或者将来有未完成订单，依然无法强制删除，请先处理订单",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            // TODO: 调用强制删除接口
            houseDel({hid: item.id, force: 1}).then((res) => {
              message.success(res.msg);
              table.getTableList();
            });
          },
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      search.checkCompanyConfig();
      table.tableHeight = countTable(search.topDom) - 10;
      modal.addForm = modal.getInitData();
    });

    return {
      ...toRefs(mapselect),
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .avatar {
    margin-right: 2px;
  }
}

.house-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 10px;
}

.modal-header {
  padding: 5px 10px;
  background-color: #f4f4f4;
}

.modal-content {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;

  .opt-one {
    padding: 1px 8px;
    border: 1px solid #f4f4f4;
    margin-right: 10px;
  }
}

.modal-ctitle {
  margin-bottom: 20px;
  padding: 5px;
  font-weight: bold;
  border-bottom: 1px solid #f2f2f2;
}

.editable-cell {
  position: relative;

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    // padding-right: 24px;
    display: flex;
    align-items: center;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    // position: absolute;
    // right: 0;
    // width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    margin-top: 4px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.expire-banner {
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 12px 16px;
  margin: 0 10px 12px 10px;

  .expire-banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    .expire-banner-title {
      color: #cf1322;
      font-size: 16px;
      font-weight: bold;
    }

    .expire-banner-info {
      color: #cf1322;
      font-size: 14px;
    }

    .expire-banner-renew {
      color: #595959;
      font-size: 14px;
    }
  }
}
</style>
